// removed by extract-text-webpack-plugin
module.exports = {"summaryTop":"summary_summaryTop_2oz1m","textBox":"summary_textBox_178hb","industry":"summary_industry_1Yfyg","assets":"summary_assets_36mlZ","structure":"summary_structure_1KoPv","text":"summary_text_E9fve"};


//////////////////
// WEBPACK FOOTER
// ./src/components/financialPicture/financialRiskAnalysis/subComponents/summary.scss
// module id = 1544
// module chunks = 0